"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const mobx_1 = require("mobx");
const class_1 = require("modules/app/services/datahub/class");
const salesManager_1 = require("modules/salesManager");
const ui_1 = require("modules/ui");
const userManager_1 = require("modules/userManager");
require("./ClassApi");
const ClassConstants_1 = require("./ClassConstants");
const ClassServiceUtil_1 = __importDefault(require("./ClassServiceUtil"));
const ClassStore_1 = __importDefault(require("./ClassStore"));
const DefaultClassUtil_1 = __importDefault(require("./DefaultClassUtil"));
const request_1 = __importDefault(require("@hotmart/request"));
const DEFAULT_TOTAL_USERS = 0;
class ClassService {
    constructor() {
        this.getBasicClass = async (classParams = {}) => {
            const classes = await this.getClasses(classParams);
            return classes.map(({ id, name, defaultClass }) => {
                return {
                    id,
                    defaultClass,
                    name: DefaultClassUtil_1.default.getName(name)
                };
            });
        };
        this.fetchFormattedClasses = async () => {
            this.setStoreData({ isFetchingFormattedClasses: true });
            let classes = await this.getClasses({
                search: ClassStore_1.default.search,
                classSort: ClassStore_1.default.classSort
            });
            const hasResults = classes.length > 0;
            if (hasResults) {
                const classIds = classes.map((item) => item.id);
                await this.fetchTotalUsersMapByClasses(classIds);
                classes = classes.map((item) => {
                    item.name = DefaultClassUtil_1.default.getName(item.name);
                    item.totalUsers =
                        ClassStore_1.default.totalUsersMap.get(item.id) || DEFAULT_TOTAL_USERS;
                    return item;
                });
            }
            class_1.DatahubClassService.sendClassSearchEvent(hasResults);
            this.setStoreData({ classes, isFetchingFormattedClasses: false });
        };
    }
    setStoreData(data = {}) {
        (0, mobx_1.extendObservable)(ClassStore_1.default, { ...data });
    }
    async getClasses({ search, classSort } = {}) {
        try {
            const params = {
                ...(search && { className: search }),
                ...(classSort && { classSort }),
                ...((search || classSort) && {
                    defaultClassName: DefaultClassUtil_1.default.getTranslatedLabel()
                })
            };
            const response = await (0, request_1.default)(ClassConstants_1.ClassEndpointKeys.GetClasses, params);
            return response.content;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
            return [];
        }
    }
    async getClassById(id) {
        try {
            const classResponse = await (0, request_1.default)(ClassConstants_1.ClassEndpointKeys.GetClassById, {
                id
            });
            return classResponse;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
            return null;
        }
    }
    async getTotalUsersByClasses(classIds = []) {
        try {
            const items = await (0, request_1.default)(ClassConstants_1.ClassEndpointKeys.GetUserCount, {
                classId: classIds.toString()
            });
            return items;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
            return [];
        }
    }
    async getClassesRelatedOffers() {
        try {
            return await (0, request_1.default)(ClassConstants_1.ClassEndpointKeys.GetMembershipClassAndOffersBySubdomain);
        }
        catch (error) {
            ui_1.UiService.handleError(error);
            return [];
        }
    }
    async create(newClass) {
        try {
            const response = await (0, request_1.default)(ClassConstants_1.ClassEndpointKeys.CreateClass, newClass);
            ui_1.UiService.setAlertSuccess('done');
            return response;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
    }
    async update(entityClass) {
        try {
            await (0, request_1.default)(ClassConstants_1.ClassEndpointKeys.UpdateClass, entityClass);
            ui_1.UiService.setAlertSuccess('done');
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
    }
    async updateClassModules({ classId, isExtraModule, selectedModuleIds }) {
        await (0, request_1.default)(ClassConstants_1.ClassEndpointKeys.UpdateClassModules, { id: classId, extra: isExtraModule }, { data: selectedModuleIds });
    }
    async delete(id, onCallback) {
        try {
            await (0, request_1.default)(ClassConstants_1.ClassEndpointKeys.DeleteClass, { id });
            ui_1.UiService.setAlertSuccess('done');
            onCallback === null || onCallback === void 0 ? void 0 : onCallback();
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
    }
    async createClass(formData, defaultClass) {
        if ((0, isEmpty_1.default)(formData)) {
            return;
        }
        const classItem = ClassServiceUtil_1.default.buildClass(formData, defaultClass);
        const response = await this.create(classItem);
        return response && response.id;
    }
    async updateClass(id, formData, defaultClass) {
        if (!id || (0, isEmpty_1.default)(formData)) {
            return;
        }
        const entityClass = ClassServiceUtil_1.default.buildClass(formData, defaultClass, id);
        await this.update(entityClass);
    }
    async fetchTotalUsersMapByClasses(classIds = []) {
        const totalUsersList = await this.getTotalUsersByClasses(classIds);
        const totalUsersMap = ClassServiceUtil_1.default.parseTotalUsersListToMap(totalUsersList);
        this.setStoreData({ totalUsersMap });
    }
    async getFormatedOffersWithClasses() {
        const offers = await salesManager_1.SalesService.getOffers();
        if (offers && offers.length) {
            const classes = await this.getClassesRelatedOffers();
            const offersMap = ClassServiceUtil_1.default.parseRelatedOffersToMap(classes);
            return offers.map((offer) => {
                const mappedClass = offersMap.get(offer.key);
                return {
                    ...offer,
                    ...(mappedClass && { class: mappedClass }),
                    ...(!mappedClass && {
                        defaultClass: true,
                        class: offersMap.get('defaultClass')
                    })
                };
            });
        }
        return [];
    }
    async searchUser(params = {}) {
        try {
            const { pagination: p, perPage: size, sortOptions } = params;
            const sort = `userName,${sortOptions.userName}`;
            const filters = ClassServiceUtil_1.default.buildFilters(params);
            return await userManager_1.UserManagerService.search({
                page: p.page,
                size,
                sort,
                filters
            });
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
    }
    async changeClass(params = {}) {
        try {
            const { selectAll, selectedClass, selectedItems: userAreaIds } = params;
            let search = null;
            if (selectAll) {
                search = { filters: ClassServiceUtil_1.default.buildFilters(params) };
            }
            await userManager_1.UserManagerService.changeClass({
                classId: selectedClass.value,
                search,
                userAreaIds: selectAll ? [] : userAreaIds
            });
            ui_1.UiService.setAlertInfo('async_operation', {});
            return true;
        }
        catch (error) {
            ui_1.UiService.handleError(error);
            return false;
        }
    }
}
__decorate([
    mobx_1.action
], ClassService.prototype, "setStoreData", null);
exports.default = new ClassService();
